export function deDasherize(str: string) {
  return str.replace(/-/g, ' ');
}
